import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ZebraService {
    private apiUrl = `${environment.zebraUrl}/print`;
    // Em desenvolvimento a listagem pede também a impressora fake do serviço local (?env=dev).
    private printersUrl = `${environment.zebraUrl}/printers${environment.printerEnv ? '?env=' + environment.printerEnv : ''}`;

    constructor() {
    }


    async sendToZebraPrinter(zebraCode: any): Promise<any> {
        // Verificar se o usuário está logado
        const token = localStorage.getItem('jwt') || localStorage.getItem('jwt-password');
        if (!token) {
            console.warn('Tentativa de impressão sem autenticação. Usuário não está logado.');
            return false;
        }

        const printerName = localStorage.getItem('printerName');
        const printFormat = localStorage.getItem('printFormat') || 'ZPL';

        try {
            const myHeaders = new Headers();
            myHeaders.append("Content-Type", "text/plain");
            
            const response = await fetch(
                `${this.apiUrl}?printerName=${printerName}&printFormat=${printFormat}`,
                {
                    method: "POST",
                    headers: myHeaders,
                    body: zebraCode,
                    redirect: "follow"
                }
            );

            return response.ok;
        } catch (error) {
            console.error('Erro ao enviar para impressora:', error);
            return false;
        }
    }

    listPrinters(): Promise<Array<{ Name: string; IsOnline: boolean; IsDefault: boolean; Status: string }>> {
        // Verificar se o usuário está logado
        const token = localStorage.getItem('jwt') || localStorage.getItem('jwt-password');
        if (!token) {
            console.warn('Tentativa de listar impressoras sem autenticação. Usuário não está logado.');
            return Promise.resolve([]);
        }

        return fetch(this.printersUrl, {
            method: "GET",
            redirect: "follow"
        }).then(response => {
            if (!response.ok) {
                throw new Error('Erro ao listar impressoras');
            }
            return response.json();
        }).then((json: any) => {
            if (json && Array.isArray(json.printers)) {
                return json.printers as Array<{ Name: string; IsOnline: boolean; IsDefault: boolean; Status: string }>;
            }
            return [];
        }).catch(err => {
            console.error('Erro ao listar impressoras:', err);
            return [];
        });
    }
}
